import userGroupTabTemplate from './userGroupTabTemplate';

export default userGroupTabTemplate(['usergroup'], ({ usergroups }) => usergroups.create);
